import { createSlice } from '@reduxjs/toolkit'
import { Dispatch } from 'redux'
import api from '../../api'

interface OrderStatusSnackbarSlice {
  orderStatusMessage: any
}

const initialStore: OrderStatusSnackbarSlice = {
  orderStatusMessage: null,
}

export const orderStatusSnackbarSlice = createSlice({
  name: 'orderStatusSnackbar',
  initialState: initialStore,
  reducers: {
    setOrderStatusMessage(store, { payload }: { payload: any }) {
      store.orderStatusMessage = payload
    },
  },
})

const { setOrderStatusMessage } = orderStatusSnackbarSlice.actions

export const getOrderStatus = () => async (dispatch: Dispatch) => {
  const { data } = await api.getOrderStatus()

  if (data) {
    dispatch(setOrderStatusMessage(data))
  }
}

export const selectOrderStatusMessage = ({ orderStatusSnackbar }: RootStore) =>
  orderStatusSnackbar.orderStatusMessage

export const orderStatusSnackbarReducer = orderStatusSnackbarSlice.reducer

export const orderStatusSnackbarReducerName = orderStatusSnackbarSlice.name

interface RootStore {
  [orderStatusSnackbarReducerName]: typeof initialStore
}
